import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-ee077d54")

_pushScopeId("data-v-ee077d54")
const _hoisted_1 = /*#__PURE__*/_createVNode("a", { style: {"color":"#fff","text-decoration":"none"} }, "安装包下载", -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode("删除数据")
const _hoisted_3 = { class: "corePerformance_app" }
const _hoisted_4 = { class: "flex_bt" }
const _hoisted_5 = /*#__PURE__*/_createVNode("span", { class: "subTitle" }, "◆", -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("span", null, "数据总览", -1)
const _hoisted_7 = {
  class: "spacName visit-record1",
  style: {"width":"100%"}
}
const _hoisted_8 = { class: "corePerformance_app" }
const _hoisted_9 = /*#__PURE__*/_createVNode("span", { class: "subTitle" }, "◆", -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("span", null, "数据对比", -1)
const _hoisted_11 = {
  class: "spacName visit-record1",
  style: {"width":"100%"}
}
const _hoisted_12 = { class: "flex_bt" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "corePerformance_app" }
const _hoisted_17 = /*#__PURE__*/_createVNode("span", { class: "subTitle" }, "◆", -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("span", null, "趋势图", -1)
const _hoisted_19 = {
  class: "FPStrend",
  style: {"width":"100%","height":"350px"}
}
const _hoisted_20 = { class: "labelStyle" }
const _hoisted_21 = /*#__PURE__*/_createVNode("div", {
  style: {"width":"100%","height":"350px"},
  id: "performance_line"
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_form = _resolveComponent("el-form")
  const _component_h7 = _resolveComponent("h7")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _component_el_card = _resolveComponent("el-card")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_container = _resolveComponent("el-container")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock(_component_el_container, null, {
    default: _withId(() => [
      _createVNode(_component_el_container, null, {
        default: _withId(() => [
          _createVNode(_component_el_main, null, {
            default: _withId(() => [
              _createVNode(_component_el_card, { class: "tableMinH" }, {
                default: _withId(() => [
                  _createVNode(_component_el_form, {
                    class: "spacForm",
                    size: "mini",
                    model: _ctx.filterList,
                    inline: true
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_form_item, { label: "日期" }, {
                        default: _withId(() => [
                          _createVNode(_component_el_select, {
                            onChange: _cache[1] || (_cache[1] = ($event: any) => (
                  _ctx.allOption([
                    'device',
                    'scene',
                    'subtype',
                    'log',
                    'dateContrast',
                  ])
                )),
                            modelValue: _ctx.filterList.date,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.filterList.date = $event))
                          }, {
                            default: _withId(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dateOptions, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.date,
                                  label: item.date,
                                  value: item.date
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { label: "机型  " }, {
                        default: _withId(() => [
                          _createVNode(_component_el_select, {
                            onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.allOption(['scene', 'subtype', 'log', 'dateContrast']))),
                            modelValue: _ctx.filterList.device,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.filterList.device = $event)),
                            placeholder: "请选择"
                          }, {
                            default: _withId(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.deviceOptions, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.device_id,
                                  label: item.name,
                                  value: item.device_id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { label: "场景" }, {
                        default: _withId(() => [
                          _createVNode(_component_el_select, {
                            onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.allOption(['subtype', 'log', 'dateContrast']))),
                            modelValue: _ctx.filterList.scene,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.filterList.scene = $event)),
                            placeholder: "请选择"
                          }, {
                            default: _withId(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sceneOptions, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.id,
                                  label: item.chinese,
                                  value: item.id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { label: "测试子类型" }, {
                        default: _withId(() => [
                          _createVNode(_component_el_select, {
                            onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.allOption(['log', 'dateContrast']))),
                            modelValue: _ctx.filterList.subtype,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.filterList.subtype = $event)),
                            placeholder: "请选择"
                          }, {
                            default: _withId(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.subtypeOptions, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.subtype,
                                  label: item.chinese,
                                  value: item.subtype
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        class: "fileWidth",
                        label: "文件"
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_select, {
                            onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.allOption(['dateContrast']))),
                            modelValue: _ctx.filterList.Journa,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.filterList.Journa = $event)),
                            placeholder: "请选择"
                          }, {
                            default: _withId(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.JournaOptions, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.id_test,
                                  label: item.time,
                                  value: item.id_test
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, null, {
                        default: _withId(() => [
                          _createVNode(_component_el_button, {
                            type: "primary",
                            size: "mini",
                            style: {"height":"28px"}
                          }, {
                            default: _withId(() => [
                              _createVNode("a", {
                                style: {"color":"#fff","text-decoration":"none"},
                                href: _ctx.appZip.file_path,
                                download: ""
                              }, "下载文件", 8, ["href"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, null, {
                        default: _withId(() => [
                          _createVNode(_component_el_button, {
                            type: "primary",
                            size: "mini",
                            style: {"height":"28px"},
                            onClick: _ctx.packageBtn
                          }, {
                            default: _withId(() => [
                              _hoisted_1
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, null, {
                        default: _withId(() => [
                          _createVNode(_component_el_button, {
                            type: "primary",
                            size: "mini",
                            style: {"height":"28px"},
                            onClick: _ctx.deleteBtn
                          }, {
                            default: _withId(() => [
                              _hoisted_2
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["model"]),
                  _createVNode("div", _hoisted_3, [
                    _createVNode("div", _hoisted_4, [
                      _createVNode(_component_h7, { style: {"display":"flex","align-items":"center"} }, {
                        default: _withId(() => [
                          _hoisted_5,
                          _hoisted_6
                        ]),
                        _: 1
                      }),
                      _createVNode("div", null, [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.resource_input,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.resource_input = $event)),
                          onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.recordSearch('resource_input'))),
                          placeholder: "搜索",
                          "prefix-icon": "el-icon-search",
                          size: "mini"
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _createVNode("div", _hoisted_7, [
                      _withDirectives(_createVNode(_component_el_table, {
                        data: _ctx.lightPerfResource.results,
                        border: "",
                        "header-cell-style": {
                  background: '#f5f7fa',
                }
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_table_column, {
                            prop: "file_name",
                            label: "文件名",
                            width: "800",
                            align: "left"
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "start",
                            label: "战斗开始(Byte)",
                            align: "center"
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "end",
                            label: "战斗结束(Byte)",
                            align: "center"
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "diff",
                            label: "Diff(Byte)",
                            align: "center"
                          })
                        ]),
                        _: 1
                      }, 8, ["data"]), [
                        [_directive_loading, _ctx.loading]
                      ]),
                      _createVNode(_component_el_pagination, {
                        currentPage: _ctx.currentPage1,
                        "onUpdate:currentPage": _cache[13] || (_cache[13] = ($event: any) => (_ctx.currentPage1 = $event)),
                        "page-size": _ctx.record,
                        layout: "total, prev, pager, next,jumper",
                        total: _ctx.lightPerfResource?.count,
                        onCurrentChange: _cache[14] || (_cache[14] = ($event: any) => (_ctx.handleCurrentChange('resource_input')))
                      }, null, 8, ["currentPage", "page-size", "total"])
                    ])
                  ]),
                  _createVNode("div", _hoisted_8, [
                    _createVNode("div", null, [
                      _createVNode(_component_h7, { style: {"display":"flex","align-items":"center"} }, {
                        default: _withId(() => [
                          _hoisted_9,
                          _hoisted_10
                        ]),
                        _: 1
                      })
                    ]),
                    _createVNode("div", _hoisted_11, [
                      _createVNode("div", _hoisted_12, [
                        _createVNode(_component_el_form, {
                          class: "spacForm",
                          size: "mini",
                          model: _ctx.filterList,
                          inline: true
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_form_item, { label: "日期选择" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_select, {
                                  modelValue: _ctx.filterList.dateResource,
                                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.filterList.dateResource = $event)),
                                  multiple: "",
                                  "collapse-tags": "",
                                  "collapse-tags-tooltip": "",
                                  onChange: _cache[16] || (_cache[16] = ($event: any) => (_ctx.cost('resource'))),
                                  placeholder: "请选择"
                                }, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.lightPerfDateContrast, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item.date,
                                        label: item.date,
                                        value: item.date
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["model"])
                      ]),
                      _withDirectives(_createVNode(_component_el_table, {
                        data: _ctx.ResourceTable.results,
                        border: "",
                        "header-cell-style": {
                  background: '#f5f7fa',
                }
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_table_column, {
                            prop: "file_name",
                            width: "450",
                            label: "文件名"
                          }),
                          _createVNode(_component_el_table_column, { label: "战斗开始(Byte)" }, {
                            default: _withId(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.resourceList.label.filter(
                      (v) => v != 'filename'
                    ), (item, index) => {
                                return (_openBlock(), _createBlock(_component_el_table_column, {
                                  "class-name": index != 0 ? 'two' : '',
                                  key: index,
                                  label: item,
                                  align: "center"
                                }, {
                                  default: _withId((scope) => [
                                    _createVNode("span", null, _toDisplayString(scope.row.start[item]), 1),
                                    (index != 0)
                                      ? (_openBlock(), _createBlock("span", _hoisted_13, _toDisplayString(_ctx.getCom(
                          scope.row.start[
                            _ctx.resourceList.label.filter((v) => v != "filename")[0]
                          ],
                          scope.row.start[item]
                        )), 1))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 2
                                }, 1032, ["class-name", "label"]))
                              }), 128))
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_table_column, { label: "战斗结束(Byte)" }, {
                            default: _withId(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.resourceList.label.filter(
                      (v) => v != 'filename'
                    ), (item, index) => {
                                return (_openBlock(), _createBlock(_component_el_table_column, {
                                  style: {"background":"#ff0"},
                                  "class-name": index != 0 ? 'two' : '',
                                  key: index,
                                  label: item,
                                  align: "center"
                                }, {
                                  default: _withId((scope) => [
                                    _createVNode("span", null, _toDisplayString(scope.row.end[item]), 1),
                                    (index != 0)
                                      ? (_openBlock(), _createBlock("span", _hoisted_14, _toDisplayString(_ctx.getCom(
                          scope.row.end[
                            _ctx.resourceList.label.filter((v) => v != "filename")[0]
                          ],
                          scope.row.end[item]
                        )), 1))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 2
                                }, 1032, ["class-name", "label"]))
                              }), 128))
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_table_column, { label: "Diff(Byte)" }, {
                            default: _withId(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.resourceList.label.filter(
                      (v) => v != 'filename'
                    ), (item, index) => {
                                return (_openBlock(), _createBlock(_component_el_table_column, {
                                  "class-name": index != 0 ? 'two' : '',
                                  key: index,
                                  label: item,
                                  align: "center"
                                }, {
                                  default: _withId((scope) => [
                                    _createVNode("span", null, _toDisplayString(scope.row.diff[item]), 1),
                                    (index != 0)
                                      ? (_openBlock(), _createBlock("span", _hoisted_15, _toDisplayString(_ctx.getCom(
                          scope.row.diff[
                            _ctx.resourceList.label.filter((v) => v != "filename")[0]
                          ],
                          scope.row.diff[item]
                        )), 1))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 2
                                }, 1032, ["class-name", "label"]))
                              }), 128))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["data"]), [
                        [_directive_loading, _ctx.ResourceTableLoading]
                      ]),
                      _createVNode(_component_el_pagination, {
                        currentPage: _ctx.currentPage4,
                        "onUpdate:currentPage": _cache[17] || (_cache[17] = ($event: any) => (_ctx.currentPage4 = $event)),
                        "page-size": _ctx.record,
                        layout: "total, prev, pager, next,jumper",
                        total: _ctx.resourceList.list?.length,
                        onCurrentChange: _cache[18] || (_cache[18] = ($event: any) => (_ctx.handleCurrentChange1('resource_input')))
                      }, null, 8, ["currentPage", "page-size", "total"])
                    ])
                  ]),
                  _createVNode("div", _hoisted_16, [
                    _createVNode(_component_h7, { style: {"display":"flex","align-items":"center"} }, {
                      default: _withId(() => [
                        _hoisted_17,
                        _hoisted_18
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form, {
                      class: "spacForm",
                      size: "mini",
                      model: _ctx.filterList,
                      inline: true
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_form_item, {
                          class: "file_width",
                          label: "文件选择"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_select, {
                              modelValue: _ctx.filterList.trendOp,
                              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.filterList.trendOp = $event)),
                              filterable: "",
                              onChange: _cache[20] || (_cache[20] = ($event: any) => (_ctx.allOption1())),
                              placeholder: "请选择"
                            }, {
                              default: _withId(() => [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.lightPerfFunctions.filenames, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.file_name,
                                    label: item.file_name,
                                    value: item.file_name
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["model"]),
                    _createVNode("div", _hoisted_19, [
                      _withDirectives(_createVNode(_component_el_card, null, {
                        default: _withId(() => [
                          _createVNode("div", _hoisted_20, _toDisplayString(_ctx.lightPerfTrend.device_name), 1),
                          _hoisted_21
                        ]),
                        _: 1
                      }, 512), [
                        [_directive_loading, _ctx.trendLoading]
                      ])
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})